module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Medium.5d0ca522.eot";